import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import seoData from '../seo/fleet.json';

const ChevyLogo = () => (
  <svg viewBox="0 0 120 44" width="32" height="12" fill="currentColor">
    <polygon points="0,22 28,2 42,2 22,22 42,42 28,42"/>
    <polygon points="78,2 92,2 120,22 92,42 78,42 98,22"/>
    <rect x="32" y="8" width="56" height="28" rx="2"/>
  </svg>
);

const CadillacLogo = () => (
  <svg viewBox="0 0 32 42" width="22" height="29" fill="currentColor">
    <path d="M16,0 L32,8 L32,30 L16,42 L0,30 L0,8 Z"/>
    <path d="M16,4 L28,10 L28,28 L16,38 L4,28 L4,10 Z" fill="var(--bg-card)"/>
    <rect x="14.5" y="7" width="3" height="28" rx="1" fill="currentColor" opacity="0.6"/>
    <rect x="6" y="19.5" width="20" height="3" rx="1" fill="currentColor" opacity="0.6"/>
  </svg>
);

export default function Fleet() {
  const vehicles = [
    {
      name: 'Chevrolet Suburban',
      type: 'Full-Size Luxury SUV',
      tag: 'Flagship',
      brand: 'Chevrolet',
      logo: <ChevyLogo />,
      image: '/images/suburban.png',
      alt: 'Black Chevrolet Suburban',
      desc: 'Our signature vehicle. The black Chevrolet Suburban delivers commanding road presence, a spacious leather interior, and exceptional comfort for up to 7 passengers. Perfect for airport transfers, corporate travel, and any occasion that demands presence.',
      specs: [
        { label: 'Passengers', value: 'Up to 7' },
        { label: 'Luggage', value: 'Large Capacity' },
        { label: 'Interior', value: 'Premium Leather' },
        { label: 'Color', value: 'Black' },
      ],
    },
    {
      name: 'Cadillac Lyriq',
      type: 'Luxury Electric SUV',
      tag: 'Electric',
      brand: 'Cadillac',
      logo: <CadillacLogo />,
      image: '/images/cadillac-lyriq.jpg',
      alt: 'Black Cadillac Lyriq',
      desc: 'The future of luxury transportation. The Cadillac Lyriq offers a whisper-quiet, all-electric ride with stunning LED lighting, a 33-inch diagonal display, and the smoothest ride technology available. Sustainable luxury at its finest.',
      specs: [
        { label: 'Passengers', value: 'Up to 5' },
        { label: 'Drive', value: 'All-Electric' },
        { label: 'Interior', value: 'Premium Leather' },
        { label: 'Color', value: 'Black' },
      ],
    },
    {
      name: 'Additional Suburbans',
      type: 'Fleet Expansion',
      tag: 'Groups',
      brand: 'Chevrolet',
      logo: <ChevyLogo />,
      image: '/images/suburban.png',
      alt: 'Multiple black Chevrolet Suburbans',
      desc: 'Need more vehicles? We can arrange additional black Chevrolet Suburbans for larger parties, wedding groups, corporate events, or any occasion requiring multiple luxury vehicles. Coordinated fleet arrivals available.',
      specs: [
        { label: 'Vehicles', value: 'Multiple' },
        { label: 'Coordination', value: 'Full Fleet Sync' },
        { label: 'Best For', value: 'Large Groups' },
        { label: 'Booking', value: 'Advance Notice' },
      ],
    },
  ];

  return (
    <>
      <SEOHead seo={seoData} />

      <section className="page-header">
        <div className="container">
          <div className="section-label">The Fleet</div>
          <h1>Our <em>Vehicles</em></h1>
          <div className="gold-line" />
          <p>
            Every vehicle in our fleet is black, meticulously detailed, and maintained to
            the highest standards. Only the best for our clients.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="fleet-showcase">
            {vehicles.map((v, i) => (
              <div className={`fleet-detail-card ${i % 2 === 1 ? 'reverse' : ''}`} key={i}>
                <div className="fleet-detail-image">
                  <img src={v.image} alt={v.alt} loading="lazy" />
                  <div className="fleet-tag">{v.tag}</div>
                </div>
                <div className="fleet-detail-body">
                  <div className="fleet-brand">
                    {v.logo}
                    <span className="fleet-brand-name">{v.brand}</span>
                  </div>
                  <h3>{v.name}</h3>
                  <div className="fleet-type">{v.type}</div>
                  <p>{v.desc}</p>
                  <div className="fleet-detail-specs">
                    {v.specs.map((s, j) => (
                      <div className="fleet-detail-spec" key={j}>
                        <div className="spec-label">{s.label}</div>
                        <div className="spec-value">{s.value}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="cta-banner">
        <div className="container">
          <h2>Reserve Your Vehicle</h2>
          <p>Contact us to book the perfect vehicle for your needs.</p>
          <div className="cta-actions">
            <a href="tel:8189154566" className="btn-primary">Call (818) 915-4566</a>
            <Link to="/contact" className="btn-outline">Contact Form</Link>
          </div>
        </div>
      </section>
    </>
  );
}
